import React from 'react'
import ImageUploader from './ImageUploader'
import Header from './Header'

const Sign_To_Text = () => {
  return (
    <>
    <ImageUploader/>
    </>
  )
}

export default Sign_To_Text
